// API base URL and key for authentication
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";
export const API_KEY = import.meta.env.VITE_API_KEY || "scopingai";

// File upload configuration
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/msword", // .doc
  "text/plain",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
  "application/vnd.ms-powerpoint", // .ppt
  "text/markdown",
];

// Document status types
export const STATUS_TYPES = {
  DRAFT: "draft",
  IN_PROGRESS: "in_progress",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  COMPLETED: "completed",
  ARCHIVED: "archived",
};

// Chat configuration
export const MAX_CHAT_HISTORY = 10;
export const MAX_CHAT_LENGTH = 4000;

// API endpoints
export const ENDPOINTS = {
  // Knowledge base
  UPLOAD_FILE: "/api/tender/documents",
  GET_DOCUMENTS: "/api/tender/knowledge/documents",
  GET_DOCUMENT: "/api/tender/knowledge/documents/:id",
  DELETE_DOCUMENT: "/api/tender/knowledge/documents/:id",
  SEARCH_DOCUMENTS: "/api/tender/knowledge/search",

  // Chat
  CHAT_COMPLETION: "/api/tender/chat/completion",
  CHAT_HISTORY: "/api/tender/chat/history",
  SAVE_CHAT: "/api/tender/chat/save",

  // Progressive scoping
  PROGRESSIVE_SCOPING: "/api/tender/scoping/progressive",
  GENERATE_SECTION: "/api/tender/scoping/section",
  SAVE_SECTION: "/api/tender/scoping/section/:id",
  GET_SECTIONS: "/api/tender/scoping/sections",

  // Optimized proposal generation
  PROPOSALS_STREAM: "/api/tender/proposals/stream",

  // Templates
  GET_TEMPLATES: "/api/templates",
  GET_TEMPLATE: "/api/templates/:id",
  SAVE_TEMPLATE: "/api/templates/:id",
  CREATE_TEMPLATE: "/api/templates",
  DELETE_TEMPLATE: "/api/templates/:id",

  // Clients
  GET_CLIENTS: "/api/clients",
  GET_CLIENT: "/api/clients/:id",
  SAVE_CLIENT: "/api/clients/:id",
  CREATE_CLIENT: "/api/clients",
  DELETE_CLIENT: "/api/clients/:id",

  // Documents
  EXPORT_PDF: "/api/tender/documents/:id/export/pdf",
  EXPORT_WORD: "/api/tender/documents/:id/export/word",
  DOCUMENT_LIBRARY: "/api/tender/documents/library",
  DOCUMENT_BY_ID: "/api/tender/documents/:id",

  // Prompt Templates
  PROMPT_TEMPLATES: "/api/tender/prompt-templates",

  // Reference Documents
  REFERENCE_DOCUMENTS: "/api/tender/reference-documents",
  REFERENCE_DOCUMENT_BY_ID: "/api/tender/reference-documents/:id",
};
